/**
 * Created by jv on 16/01/2017.
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import AppError from "Sources/models/app-error";

let request = {};

(function(Request)
{
  Request.CONTENT_TYPES = {
    APPLICATION_FORM_URLENCODED: "application/x-www-form-urlencoded",
    TEXT_PLAIN: "text/plain",
    APPLICATION_JSON: "application/json",
  };

  Request.DATA_TYPES = {
    TEXT: "text",
    JSON: "json",
    XML: "xml"
  };

  Request.get = function(options)
  {
    options.type = "GET";
    return doRequest(options);
  };

  Request.post = function(options)
  {
    options.type = "POST";
    return doRequest(options);
  };

  Request.put = function(options)
  {
    options.type = "PUT";
    return doRequest(options);
  };

  Request.delete = function(options)
  {
    options.type = "DELETE";
    return doRequest(options);
  };

  function doRequest(options)
  {
    let startTime = Date.now();
    logRequestInfo(startTime, options);

    // Download / Upload progress
    if(utils.isFunction(options.onProgress) || utils.isFunction(options.onUploadProgress))
    {
      options.xhr = function()
      {
        let xhr = new window.XMLHttpRequest();

        if(utils.isFunction(options.onUploadProgress))
        {
          xhr.upload.addEventListener("progress", function(evt)
          {
            if(evt.lengthComputable)
            {
              let percentComplete = evt.loaded / evt.total;
              options.onUploadProgress(percentComplete);
            }
          }, false);
        }

        if(utils.isFunction(options.onProgress))
        {
          xhr.addEventListener("progress", function(evt)
          {
            if(evt.lengthComputable)
            {
              let percentComplete = evt.loaded / evt.total;
              options.onProgress(percentComplete);
            }
          }, false);
        }

       return xhr;
      };
    }

    if(options.type !== "GET" && options.contentType === Request.CONTENT_TYPES.APPLICATION_JSON && (utils.isObject(options.data) || utils.isArray(options.data)))
    {
      options.data = utils.stringifyJSON(options.data);
    }

    return new Promise((resolve, reject) =>
    {
      // Request (order matters! in this case: always -> done / fail)
      $.ajax(options)
      .always(function(data, textStatus)
      {
        logRequestComplete(startTime, options, textStatus, data);
      })
      .done(function(data)
      {
        if(utils.isNotNull(data) && data.hasOwnProperty("responseJSON") && data.responseJSON.result === "error")
        {
          dataToError(data, reject);
          return;
        }

        resolve(data);
      })
      .fail(function(data)
      {
        dataToError(data, reject);
      });
    });
  }

  function logRequestInfo(startTime, requestOptions)
  {
    let startColor = "#5076ff";
    let headerCss = utils.format("background-color: #222;color: {0};border-top: 1px solid {1};", startColor, startColor);
    let footerCss = utils.format("border-bottom: 1px solid {0}", startColor);
    log.info("%cRequest started%c\nUrl: %s\nMethod: %s\nContent-type: %s\nDataType: %s\n%cData: %o%c", headerCss, "", requestOptions.url, requestOptions.type, requestOptions.contentType, requestOptions.dataType, footerCss, requestOptions.data, "");
  }

  function logRequestComplete(startTime, requestOptions, textStatus, result)
  {
    if(__DEVELOPMENT__)
    {
      let executeTime = Date.now() - startTime;
      executeTime = (executeTime / 1000) + "s";

      let completeColor = "#bada55";
      let headerCss = utils.format("background-color: #222;color: {0};border-top: 1px solid {1};", completeColor, completeColor);
      let footerCss = utils.format("border-bottom: 1px solid {0}", completeColor);

      log.info("%cRequest complete%c\nUrl: %s\nMethod: %s\nStatus: %s\nExecute time: %s\n%cResult: %o%c",
                /*empty string to reset css*/
        headerCss, "", requestOptions.url, requestOptions.type, textStatus, executeTime, footerCss, result, "");
    }
  }

  function dataToError(data, callback)
  {
    if(utils.isFunction(callback))
    {
      if(utils.isNotNull(data) && data.hasOwnProperty("responseJSON") && utils.isNotNull(data.responseJSON) && data.responseJSON.result === "error")
      {
        callback(new AppError({
          code: data.responseJSON.data.appErrorCode,
          message: data.responseJSON.data.message,
          data
        }));
      }
      else if(data.status === 401)
      {
        callback(new AppError({
          code: "401",
          message: utils.isNotNull(data.responseJSON) ? data.responseJSON.data : data.responseText,
          data
        }));
      }
      else
      {
        callback(new AppError({
          code: null,
          message: null,
          data
        }));
      }
    }
  }
}(request));

module.exports = request;



// WEBPACK FOOTER //
// ./app/js/services/request.js